import { IncorrectRecordingLocationRequestDto } from '../../types';
import { useGetIncorrectRecordingLocationTicketListQuery } from '../../services';

export function useIncorrectRecordingLocationList(
  IncorrectRecordingLocationRequestDto: IncorrectRecordingLocationRequestDto
) {
  const {
    data: incorrectRecordingLocaitonList,
    isLoading,
    refetch
  } = useGetIncorrectRecordingLocationTicketListQuery(IncorrectRecordingLocationRequestDto!, {
    skip: !IncorrectRecordingLocationRequestDto,
    refetchOnMountOrArgChange: true
  });

  return {
    incorrectRecordingLocation: incorrectRecordingLocaitonList?.data.rows || [],
    incorrectRecordingLocationCount: Number(incorrectRecordingLocaitonList?.data.count),
    refetch: refetch ?? (() => {}),
    isLoading
  };
}
